/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-mate.chat-error-banner.description': 'Tu historial de chat se guarda durante un máximo de 30 días.',
  'ai-mate.chat-error-banner.title': 'Iniciar nuevo chat',
  'ai-mate.chat-error.description': 'Prueba a <btn>volver a cargar el chat</btn>.',
  'ai-mate.chat-error.rate-limited-description':
    'Has alcanzado el número máximo de solicitudes. Inténtalo de nuevo más tarde.',
  'ai-mate.chat-error.rate-limited-title': 'Demasiadas solicitudes',
  'ai-mate.chat-error.rovo-inactive-description':
    'Parece que Rovo no está activado en tu sitio. <link>Configurar Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo está inactivo',
  'ai-mate.chat-error.title': 'No tenemos claro qué ha salido mal',
  'conversation-assistant-button.label': 'Chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat de Rovo',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Pregúntale a la IA sobre esto',
  'highlight-actions.rovo-chat-explain-option.text': 'Explicar',
  'highlight-actions.rovo-chat-explain-prompt': 'Explicar esto: {selectedText}',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Recomendaciones de chat',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Abrir chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Resumir',
  'highlight-actions.rovo-chat-summarize-prompt': 'Resumir esto: {selectedText}',
  'highlight-actions.rovo-chat.button-text': 'Chat',
  'horizontal-scroll-container.scroll-left': 'Desplazarse a la izquierda',
  'horizontal-scroll-container.scroll-right': 'Desplazarse a la derecha',
};
